var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcYoutubeOval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30.0 30.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1554 L0,1554 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2842712,0 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 0,23.2842712 0,15 C0,6.71572875 6.71572875,0 15,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.64,0 C15.3066667,0 16.6666667,1.36666667 16.6666667,3.02666667 L16.6666667,8.58 C16.6666667,10.2466667 15.3066667,11.6066667 13.64,11.6066667 L3.02666667,11.6066667 C1.36,11.6066667 0,10.2466667 0,8.58 L0,3.02666667 C0,1.36 1.36,0 3.02666667,0 Z M6.21333333,2.64666667 L6.21333333,9.04666667 L8.8,7.44666667 L11.3866667,5.84666667 L8.8,4.24666667 L6.21333333,2.64666667 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-493.0 -471.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.0 200.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0 60.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 26.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 135.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.0 50.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 30,0 30,30 0,30 0,0",
    stroke: "none",
    fill: "#E53934"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.666666666666668 9.193333333333335)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16.6666667,0 16.6666667,11.6066667 0,11.6066667 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutubeOval);
export default __webpack_public_path__ + "static/media/icYoutubeOval.797c248aea5ab6b4148624e179833d3b.svg";
export { ForwardRef as ReactComponent };